import {   month_th_abbreviation , month_eng_abbreviation } from '@/utils.js'


export default {
    methods:{
        getISO8601ToYearMonthDate(dat){
            if(dat === null){
                return {
                    year : "",
                    month : "",
                    date:"",
                    hour : "",
                    minute: ""
                }
            }


            const   date = new Date(dat)
            var tmpHour = date.getHours()
            var tmpMinute = date.getMinutes()
            var tmpSecond = date.getSeconds()
            if(tmpHour.toString().length === 1){
                tmpHour = '0'+tmpHour
            }
            if(tmpMinute.toString().length === 1){
                tmpMinute = '0'+tmpMinute
            }

            if(tmpSecond.toString().length === 1){
                tmpSecond = '0'+tmpSecond
            }



            return {
                year_th : date.getFullYear()+543,
                year : date.getFullYear(),
                month_th : month_th_abbreviation[(date.getMonth())],
                month:  month_eng_abbreviation[(date.getMonth())],
                date :date.getDate(),
                hour : tmpHour,
                minute: tmpMinute,
                second:tmpSecond
            }
        }
    },



}